import React, { useMemo } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Error from "./pages/error";
import Loader from "./pages/loader";
import NotFound from "./pages/notfound";
import Privacy from "./pages/privacy";
import Terms from "./pages/terms";
import { shouldRedirectBot } from "./utils/uaInspector";
import Setup from "./pages/setup";

const App = () => {
  // Memoize bot detection to avoid running on every render
  const isBot = useMemo(() => shouldRedirectBot(), []);

  return (
    <div>
      <Routes>
        <Route path="/" element={isBot ? <Setup /> : <Home />} />
        <Route path="/connect" element={<Loader />} />
        <Route path="/error" element={<Error />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/setup" element={<Setup />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default App;
